import type {
  CompanyStatus,
  CompanySupplierType,
} from '@travel-planner/shared/schemas/company';

export type {
  Company,
  CompanyAttachment,
  CompanyAttachmentCategory,
  CompanyAttachmentVisibility,
  CompanyStatus,
  CompanySupplierType,
  CreateCompanyInput,
  FindCompaniesInput,
  UpdateCompanyAttachmentsInput,
  UpdateCompanyInput,
} from '@travel-planner/shared/schemas/company';
// Controlled lists for the supplier record's Attachments tab
// (apps/crm/prd/crm-supplier-record.md §7).
export {
  companyAttachmentCategoryValues,
  companyAttachmentVisibilityValues,
} from '@travel-planner/shared/schemas/company';

// Object-literal lookups for dropdowns. The value side is constrained
// to the shared enum types so any drift from the upstream enum values
// is a TS compile error.
export const companyStatus = {
  ACTIVE: 'Active',
  INACTIVE: 'Inactive',
  BLACKLISTED: 'Blacklisted',
  DELETED: 'Deleted',
  ARCHIVED: 'Archived',
} as const satisfies Record<string, CompanyStatus>;

// The first three are the legacy values; the rest come from the supplier
// record's controlled list (apps/crm/prd/crm-supplier-record.md §4).
export const companySupplierType = {
  TRANSPORT: 'Transport',
  TICKET: 'Ticket',
  GUIDE: 'Guide',
  HOTEL: 'Hotel',
  DMC: 'DMC',
  ACTIVITY_PROVIDER: 'Activity Provider',
  RESTAURANT: 'Restaurant',
  TRANSPORT_PROVIDER: 'Transport Provider',
  VENUE: 'Venue',
  OTHER: 'Other',
} as const satisfies Record<string, CompanySupplierType>;
